import React from 'react';
import { Box, BoxProps, Typography } from '@mui/material';
import NoDataIcon from '../../../assets/svg-fc/NoDataIcon';
import './noData.css';

interface INoDataProps extends BoxProps {
  className?: string;
  message?: string;
}

const NoData = ({ className, message = 'No data', ...props }: INoDataProps) => {
  return (
    <Box {...props} className={`noDataContainer ${className}`}>
      <NoDataIcon />
      <Typography className="noDataText">{message}</Typography>
    </Box>
  );
};

export default NoData;
